export const productSearchSessionKey = 'thg-product-search-response';
export const extendedBookingSessionKey = 'thg-extended-booking-data';
export const eCommerceSessionKey = 'thg-ecommerce-data';
export const summaryOverviewSessionKey = 'thg-summary-overview-data';
export const productSearchSessionTempKey = 'thg-product-search-response-temp';
